import { Helmet } from 'react-helmet-async';
import { useMemo } from 'react';

export const usePageMeta = (title: string, description?: string) => {
  return useMemo(
    () => (
      <Helmet>
        <title>{title} </title>
        {description && <meta name="description" content={description} />}
      </Helmet>
    ),
    [title, description]
  );
};
